/**
 * @generated SignedSource<<226fe13bf338846c25ce08748e3d35ed>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsLanding_item$data = {
  readonly isListingNotListed: boolean | null;
  readonly isListingUnlisted: boolean | null;
  readonly isSold: boolean | null;
  readonly seller: {
    readonly isAccessible: boolean | null;
    readonly isInternal: boolean | null;
  } | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsContainer_item" | "PdpSharedUnpurchasableHeader_item">;
  readonly " $fragmentType": "PdpRespSimilarItemsLanding_item";
};
export type PdpRespSimilarItemsLanding_item$key = {
  readonly " $data"?: PdpRespSimilarItemsLanding_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsLanding_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItemsLanding_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isListingNotListed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isListingUnlisted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isInternal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedUnpurchasableHeader_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsContainer_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "982e029fa8ae4dc903cb4a23cd438dcf";

export default node;
